import { useEffect, useRef, useState } from "react";
import imgLeftOpen from "../../../images/loxomy-profile-left-open.png";
import imgRightOpen from "../../../images/loxomy-profile-right-open.png";
import imgLeftClose from "../../../images/loxomy-profile-left-close.png";
import imgRightClose from "../../../images/loxomy-profile-right-close.png";
import imgBox from "../../../images/box.png";
import imgCurtain from "../../../images/curtain.png";
import imgMissingBox from "../../../images/missing-box.png";
import { getVehicleOverview } from "../../../fetchApi";

export default function Overview({ vehicleId, highlight }) {
  const intervalRef = useRef(null);
  const imagesRef = useRef(null);
  const [vehicleOverview, setVehicleOverview] = useState(null);

  useEffect(() => {
    const images = imagesRef.current;
    const drawDoors = true;

    function drawDoor(closeImg, percent, ctx, x_offset, y_offset) {
      const closedDoorHeight = 200;
      const openDoorHeight = 900;
      const doorHeight = closedDoorHeight + (openDoorHeight - closedDoorHeight) * (1 - percent);
      ctx.globalAlpha = 0.8;
      ctx.drawImage(closeImg, 0, 0, 1920, doorHeight, x_offset, y_offset, 1920, doorHeight);
      ctx.globalAlpha = 1.0;
    }

    function clear() {
      const canvas = document.getElementById("canvas");
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }

    function draw(vehicle) {
      const canvas = document.getElementById("canvas");
      const ctx = canvas.getContext("2d");

      ctx.save();
      ctx.translate(0.5, 0.5);

      ctx.drawImage(images.get("leftOpen"), 0, 0);
      ctx.drawImage(images.get("rightOpen"), 1920, 0);

      let idx = 0;
      vehicle.boxes.forEach((box) => {
        let x_offset = 0;
        let y_offset = 0;
        let x = 228;
        let y = 230;

        if (idx < 4) {
          // left side
          x_offset = 0;
          y_offset = 0;
        } else {
          // right side
          x_offset = 1910;
          y_offset = 0;
        }

        if (idx % 4 < 3) {
          // top row
          x += (idx % 4) * (488 + 5);
        } else {
          // bottom row
          y += 300;
          x += 488 + 5;
        }

        if (box) {
          drawBox(box, x + x_offset, y + y_offset, ctx);
        } else {
          drawMissingBox(x + x_offset, y + y_offset, ctx);
        }

        idx++;
      });

      if (drawDoors) {
        const leftDoorPercent = vehicle.doors.left.position / 100;
        const rightDoorPercent = vehicle.doors.right.position / 100;

        drawDoor(images.get("leftClose"), leftDoorPercent, ctx, 0, 0);
        drawDoor(images.get("rightClose"), rightDoorPercent, ctx, 1920, 0);
      }

      ctx.fillStyle = "white";
      outlinedText(ctx, "Left (back)", 1920 / 2, 100, 120);
      outlinedText(ctx, "Right (front)", (1920 / 2) * 3, 100, 120);

      const tablet = {
        x: 3360,
        y: 630,
        w: 140,
        h: 110,
      };
      ctx.lineWidth = 40;
      ctx.strokeStyle = "black";
      ctx.fillStyle = "#505050";
      ctx.beginPath();
      ctx.rect(tablet.x - tablet.w / 2, tablet.y - tablet.h / 2, tablet.w, tablet.h);
      ctx.stroke();
      ctx.fill();

      ctx.restore();
    }

    function drawBox(box, x, y, ctx) {
      const boxImg = images.get("box");
      const boxSize = 4 * 183;
      const margin = 20;

      const width = boxImg.width - margin;
      const height = boxImg.height - margin;
      const left = (box.leftCurtain / boxSize) * width;
      const right = width - (box.rightCurtain / boxSize) * width;

      ctx.drawImage(boxImg, x, y);
      drawCurtains(x + margin / 2, y + margin / 2, width, height, left, right, ctx);

      highlight
        ?.filter((h) => h.boxIdx === box.idx)
        .forEach((h) => {
          let realLeft = 0;
          let realRight = 0;
          for (const comp of box.compartments) {
            if (comp.idx < h.fromCompartmentIdx) {
              realLeft += comp.size;
            }
            if (comp.idx <= h.toCompartmentIdx) {
              realRight += comp.size;
            }
          }

          const left = (realLeft / boxSize) * width;
          const right = (realRight / boxSize) * width;

          ctx.strokeStyle = "#0d6efd";
          ctx.lineWidth = 20;
          ctx.beginPath();
          ctx.rect(x + margin / 2 + left, y + margin / 2, right - left, height);
          ctx.stroke();
        });

      // draw box name
      ctx.fillStyle = "white";
      outlinedText(ctx, `Box ${box.idx}`, x + boxImg.width / 2, y + boxImg.height / 3, 80);

      // draw compartment names
      ctx.fillStyle = "white";
      ctx.lineWidth = 15;

      let compartmentOffset = 0;
      for (const compartment of box.compartments) {
        outlinedText(
          ctx,
          `C${compartment.idx}`,
          x + ((compartment.size / 2 + compartmentOffset) / boxSize) * width,
          y + (boxImg.height / 4) * 3,
          70
        );

        compartmentOffset += compartment.size;
      }
    }

    function outlinedText(ctx, text, x, y, size) {
      ctx.save();

      ctx.textBaseline = "middle";
      ctx.textAlign = "center";
      ctx.lineJoin = "round";
      ctx.font = `bold ${size}px Arial`;
      ctx.lineWidth = 0.2 * size;
      ctx.miterLimit = 2;
      ctx.shadowBlur = 20;
      ctx.shadowColor = "black";

      for (let i = 0; i < 5; i++) ctx.fillText(text, x, y);

      ctx.restore();
    }

    function drawMissingBox(x, y, ctx) {
      const missingBoxImg = images.get("missingBox");
      ctx.drawImage(missingBoxImg, x, y);
    }

    function drawCurtains(box_x, box_y, box_w, box_h, left, right, ctx) {
      const curtainImg = images.get("curtain");
      const width = curtainImg.width;
      const height = curtainImg.height;

      const left_sx = width - left;
      const left_sy = 0;
      const left_sw = left;
      const left_sh = height;
      const left_dx = box_x;
      const left_dy = box_y;
      const left_dw = left;
      const left_dh = box_h;

      const right_sx = 0;
      const right_sy = 0;
      const right_sw = right;
      const right_sh = height;
      const right_dx = box_x + box_w - right;
      const right_dy = box_y;
      const right_dw = right;
      const right_dh = box_h;

      ctx.drawImage(
        curtainImg,
        left_sx,
        left_sy,
        left_sw,
        left_sh,
        left_dx,
        left_dy,
        left_dw,
        left_dh
      );
      ctx.drawImage(
        curtainImg,
        right_sx,
        right_sy,
        right_sw,
        right_sh,
        right_dx,
        right_dy,
        right_dw,
        right_dh
      );
    }

    clear();

    if (vehicleOverview != null && vehicleOverview.id) {
      draw(vehicleOverview);
    }
  }, [vehicleOverview, highlight]);

  useEffect(() => {
    const imagesUrl = {
      leftOpen: imgLeftOpen,
      rightOpen: imgRightOpen,
      leftClose: imgLeftClose,
      rightClose: imgRightClose,
      box: imgBox,
      curtain: imgCurtain,
      missingBox: imgMissingBox,
    };

    imagesRef.current = new Map();

    const fetchData = async () => {
      setVehicleOverview(await getVehicleOverview(vehicleId));
    };

    let imageLoadedCount = 0;
    function onImageLoaded() {
      imageLoadedCount++;
      if (imageLoadedCount === Object.keys(imagesUrl).length) {
        intervalRef.current = setInterval(fetchData, 500);
      }
    }

    for (const key in imagesUrl) {
      const image = new Image();

      image.src = imagesUrl[key];
      image.onload = onImageLoaded;

      imagesRef.current.set(key, image);
    }

    return () => clearInterval(intervalRef.current);
  }, [vehicleId]);

  return (
    <div style={{ marginLeft: "auto", textAlign: "center" }}>
      <canvas
        id="canvas"
        width="3840"
        height="1080"
        style={{
          width: "100%",
          maxWidth: 900,
          aspectRatio: "32 / 9",
          backgroundColor: "hsl(0 0% 70%)",
        }}
      ></canvas>
    </div>
  );
}
